import React, { useEffect, useState } from 'react'
import Modal from 'react-modal/lib/components/Modal';
import './ModalProduto.css'
import BuscaVazaia from '../buscavazia/buscaVazia';
import api from '../../../services/api';
import { vhostV1 } from '../../funcoes';
import customizeScrollbar from 'customsb';


function ModalProduto({isOpen,onRequestClose,setCodProduto,setDescricao,setVendaDefault,setNcm,setCompra,setEstoque}){

  const inputs = document.querySelectorAll("input, select, NumericFormat ,button ");
    // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
    inputs.forEach(input => {
      input.addEventListener("keydown", e => {
        // Se a tecla pressionada for Enter
        if (e.key === "Enter") {
          e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

          if (e.target.tagName.toLowerCase() === "button") {
            e.target.click(); // Dispara o evento de clique do botão
          } else {
          // Obtenha o índice do elemento atual
          const currentIndex = Array.from(inputs).indexOf(e.target);
  
          // Mova o foco para o próximo elemento de entrada ou select
          const nextIndex = currentIndex + 1;
          if (nextIndex < inputs.length) {
            inputs[nextIndex].focus();
          }
        }
      }
      });
    }); 

  let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  useEffect(() => {
    // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);

  const [produtos,setProdutos] = useState([]);
  const [busca,setBusca] = useState('');
  
  // const [codProduto, setCodProduto] = useState('');
  // const [descricao, setDescricao] = useState('');
  // const [vendaDefault, setVendaDefault] = useState(0);

  const diferenteZero = false;
  const estoqueNegativo = false;
  const vendaZerada = false;
  const prodInativo =false;

  useEffect(() => {
    filtraProdutos();
  },[])

  function filtraProdutos(){
  const sJson = {}
  sJson.loja=localStorage.getItem('loja'); 
  sJson.empresa=0;
  sJson.grupo=0;
  sJson.subgrupo=0;
  sJson.linha=0;
  sJson.estoque_diferente=diferenteZero
  sJson.estoque_negativo=estoqueNegativo;
  sJson.preco_zerado=vendaZerada;
  sJson.inativo=prodInativo;
  sJson.pagina= 1;
  sJson.regPag=10;
  sJson.busca= busca; 
  sJson.tipoBusca=0; 
  sJson.tipo_prod=''; 
 
    api.post(vhostV1('webcash/produto/listar'),sJson,config)
      .then(function (response) {
          if(response && response.data && response.data.dados ){
            console.log(response.data.dados)
            setProdutos(response.data.dados);  
          }else{ 
          setProdutos([]);  
      }
                                    
      })
      .catch(function (error) {
        console.log(error);                  
      });
        
}              

 function truncateText(text, maxLength) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

  function handelProduto(prod){
     setCodProduto(prod.COD_PRODUTO);
     setDescricao(prod.DESCRICAO);
     setVendaDefault(Number(prod.VENDA));
     setNcm(prod.COD_NCM);
     setCompra(prod.COMPRA);
     setEstoque(prod.ESTOQUE);
     onRequestClose(prod.COD_PRODUTO);

  }



  return <Modal isOpen={isOpen}
                onRequestClose={onRequestClose}
                overlayClassName="react-modal-overlay"
                ariaHideApp={false}
                className="react-modal-content">
          <div className="container-fluid pesquisa-modal">
            <div className="row">
                <h4>Pesquisa Produtos</h4>              
                <hr />
                
                <div className="col-12">
                <div className="input-group mb-3">
                <input onChange={(e) => setBusca(e.target.value)} type="text" className="form-control" placeholder="Pesquisar por nome" aria-describedby="button-addon2" autoFocus />
                <button onClick={(e) => filtraProdutos(e.target.value)} value={busca}  className="btn btn-primary" type="button" id="button-addon2"><i className="bi bi-search"></i> Pesquisar</button>
                
               
                </div>
                </div>       
            </div> 

           <div className="row produtos">
           
           { produtos.length > 0?
                                <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">Codigo</th>
                                    <th scope="col">Descrição</th>
                                    <th scope="col">Estoque</th>
                                    <th scope="col">Ação</th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                { produtos.map((prod)=> {
                                    return <tr key={prod.COD_PRODUTO}>
                                        <td>{prod.COD_PRODUTO}</td>          
                                        <td>{truncateText(prod.DESCRICAO, 45)}</td>
                                        <td>{Number(prod.ESTOQUE).toFixed(3)}</td>
                                        <td>
                                          <button  onClick={(e) => handelProduto(prod)}>
                                          <i class="bi bi-file-arrow-down-fill"></i>
                                          </button>                                        
                                        </td>
                                    </tr>
                                } )}  
                                </tbody>
                            </table>:<BuscaVazaia/>}

           </div>
            
           <div className="row align-items-end">
                <button className='btn btn-danger botao-fechar'onClick={onRequestClose}>Cancelar</button>
            </div>
            
          </div>
    

    
  </Modal>
}

export default ModalProduto;